/** Préfixe `/portal/*` : shell admin dédié (fenêtre séparée pour les officiers). */

export const PORTAL_LOGIN_PATH = '/portal/login';

export function isPortalAdminPath(pathname) {
  return typeof pathname === 'string' && pathname.startsWith('/portal');
}

export {
  resolveLoginPath,
  resolveMemberLoginPath,
  resolveFirstLoginPasswordPath,
  WEB_LOGIN_PATH,
  MOBILE_LOGIN_PATH,
  MOBILE_UNLOCK_PATH,
  MOBILE_SETUP_PIN_PATH,
  MOBILE_FIRST_LOGIN_PASSWORD_PATH,
  isMobileAuthPath,
  isMobileViewport,
} from './authRoutes';

export function staffUsersBasePath(pathname) {
  return isPortalAdminPath(pathname) ? '/portal/users' : '/users';
}

export function staffUsersListPath(pathname) {
  return staffUsersBasePath(pathname);
}

export function staffMembersBasePath(pathname) {
  return isPortalAdminPath(pathname) ? '/portal/members' : '/members';
}

export function staffMembersListPath(pathname) {
  return staffMembersBasePath(pathname);
}

const PORTAL_NAV_HREF_MAP = {
  '/admin': '/portal',
  '/admin/ledgera': '/portal/ledgera',
  '/users': '/portal/users',
  '/roles': '/portal/roles',
  '/settings': '/portal/settings',
  '/members': '/portal/members',
  '/contributions': '/portal/contributions',
  '/assistance': '/portal/assistance',
  '/dashboard': '/portal',
  '/commissions': '/portal/commissions',
  '/modules': '/portal/modules',
};

/**
 * Sous `/portal/*`, réécrire les href de la sidebar admin pour rester dans la session portal.
 */
export function toPortalAdminNavHref(pathname, href) {
  if (!href || !isPortalAdminPath(pathname)) return href;
  return PORTAL_NAV_HREF_MAP[href] || href;
}

export function isPortalAdminNavActive(pathname, canonicalHref, resolvedHref) {
  const target = resolvedHref || canonicalHref;
  if (!target) return false;
  if (pathname === target) return true;
  if (target !== '/' && pathname.startsWith(`${target}/`)) return true;
  if (
    (canonicalHref === '/admin' || canonicalHref === '/dashboard') &&
    (pathname === '/portal' || pathname === '/admin')
  ) {
    return true;
  }
  return false;
}
